import { Component, Input, OnInit } from '@angular/core';
import { IFolderSquare } from '../../../interfaces/folder-square.interface';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-folder-square',
  templateUrl: './folder-square.component.html',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  styleUrls: ['./folder-square.component.scss'],
})
export class FolderSquareComponent implements OnInit {
  @Input({ required: true }) folderSquareData?: IFolderSquare;

  constructor() {}

  ngOnInit() {}
}
